import React, { useState, useEffect } from "react";
import translate from "../../../i18n/translate";
import ProductCard from "../ProductCard/ProductCard";
import "./RecomendedCarouselComponent.scss";
import { useSelector } from "react-redux";
import { hideToolsMenu, toolsToShow } from "../Header/HeaderUtils";

const RecomendedCarouselComponent: React.FC = () => {
  let [isNewsfeedfeatureenabled] = useState(false);
  const [isCultureCentrefeatureenabled, setCultureNotesfeatureenabled] = useState(false);
  const [isTWTfeatureenabled, setTWTfeatureenabled] = useState(false);
  const [isStressAndIntonationEnabled, setIsStressAndIntonationEnabled] = useState(false);
  const [isSoundsOfEnglishEnabled, setIsSoundsOfEnglishEnabled] = useState(false);
  const [, setIndustryFeedEnabled] = useState(false);
  const allInfo = useSelector((state: any) => state);
  const [isOneUser, setIsOneUser] = useState<boolean | null>(null);
  const[showTools,setShowTools] = useState<boolean>(false)
  const[hideFeatures,setHideFeatures] = useState<boolean>(false)

  const afterGetLearnerInfo = (data: any) => {
    if (data.data.getpeopleInformation.serviceConfiguration.features.substring(27, 28) === "1") {
      setCultureNotesfeatureenabled(true);
    }

    if (data.data.getpeopleInformation.serviceConfiguration.features.substring(11, 12) === "1") {
      setTWTfeatureenabled(true);
    }

    if (data.data.getpeopleInformation.serviceConfiguration.features.substring(53, 54) === "1") {
      setIsStressAndIntonationEnabled(true);
      setIsSoundsOfEnglishEnabled(true);
    }
    if (data.data.getpeopleInformation.serviceConfiguration.features.substring(47, 48) === "1") {
      setIndustryFeedEnabled(true);
    }
  };

  useEffect(() => {
    if (
      !allInfo.common.isLoading &&
      !allInfo.peopleInformation.isLoading &&
      !allInfo.learnerTasks.isLoading &&
      !allInfo.jwkPublicKey.isLoading
    ) {
      if (!allInfo.peopleInformation.isFailed && allInfo.peopleInformation.data) {
        afterGetLearnerInfo(allInfo.peopleInformation);
      }
    }
    if (
      allInfo.peopleInformation &&
      allInfo.peopleInformation.data &&
      allInfo.peopleInformation.data.getpeopleInformation &&
      allInfo.peopleInformation.data.getpeopleInformation &&
       process.env.REACT_APP_ENVIRONMENT !== "prod"
    ) {
      const license = allInfo.peopleInformation.data.getpeopleInformation.license;
      if (typeof license === "object" && license.length > 0) {
        const isProductOne = license.findIndex((eachObject: any) => eachObject.productId === "1");
        enableFeatures()    
        if (isProductOne !== -1) {
          setIsOneUser(true);
        } else {
          setIsOneUser(false);
        }
      }
    } else if (process.env.REACT_APP_ENVIRONMENT === "prod") {
      enableFeatures()
      setIsOneUser(false);
    }
  }, [allInfo.common, allInfo.peopleInformation, allInfo.learnerTasks, allInfo.jwkPublicKey]);

  function enableFeatures(){
    const license = allInfo.peopleInformation.data.getpeopleInformation.license;
    const fetchProductId = license.map((product:any) => {
      return product.productId;
    });
    const show = fetchProductId.some(toolsToShow);
      setShowTools(show);
      if(fetchProductId.length ===1){
        const hideFeature = fetchProductId.some(hideToolsMenu) 
        setHideFeatures(hideFeature)
      }
  }

  return (
    <>
    {!hideFeatures && (
  <div className="RecomendedCarouselCotainer">
  <div className="Listalign PageContainerBlock">
    <h1 className="headeralign"> {translate("title_feature")} </h1>
    <div className="featuresCardsContainer">
      {isCultureCentrefeatureenabled && (
        <ProductCard
          title={translate("feature_culture_centre_title")}
          summary={translate("culturenotes_mainintrotext")}
          iconFontClass="string"
          headColorClass="string"
          roundButtonText="Buy Now"
          flatButtonText={translate("button_GetStarted")}
          productcardclass="recommended-card"
          cardimage="Feature_Illustrations/Culture-notes.svg"
          redirectURL={`/culturecenter`}
        />
      )}
      <ProductCard
        title={translate("feature_emailTemplates_title")}
        summary={translate("Blob")}
        iconFontClass="string"
        headColorClass="coach"
        roundButtonText="Buy Now"
        flatButtonText={translate("button_GetStarted")}
        productcardclass="recommended-card"
        cardimage="Feature_Illustrations/Email-templates.svg"
        redirectURL={`/emailtemplates`}
      />
      {
        showTools && (
          <ProductCard
        title={translate("vocab_center_product_headline")}
        summary={translate("vocab_center_feature_summary")}
        iconFontClass="string"
        headColorClass="string"
        roundButtonText="Buy Now"
        flatButtonText={translate("button_GetStarted")}
        productcardclass="recommended-card"
        cardimage="Feature_Illustrations/Vocabulary-center.svg"
        redirectURL={`/vocabularycenter`}
      />
        )
      }
      
      {isTWTfeatureenabled && (
        <ProductCard
          title={translate("feature_talkWithTeacher_title")}
          summary={translate("feature_talkWithTeacher_desc")}
          iconFontClass="string"
          headColorClass="coach"
          roundButtonText="Buy Now"
          flatButtonText={translate("button_view")}
          productcardclass="recommended-card"
          cardimage="Feature_Illustrations/Talk-with-a-teacher.svg"
          redirectURL={`/twt`}
        />
      )}

      {isNewsfeedfeatureenabled && (
        <ProductCard
          title={translate("dailyNewsFeed_newsfeedoftheday")}
          summary={translate("feature_newsFeed_desc")}
          iconFontClass="string"
          headColorClass="virtual"
          roundButtonText="Buy Now"
          flatButtonText={translate("button_GetStarted")}
          productcardclass="recommended-card"
          cardimage="Feature_Illustrations/News-feed.svg"
          redirectURL={`${window.location.protocol}//newsfeed.globalenglish.com`}
        />
      )}
        {
          showTools && (
            <ProductCard
        title={translate("accentsAndDialects_heading")}
        summary={translate("feature_accentsAndDialects_desc")}
        iconFontClass="string"
        headColorClass="string"
        roundButtonText="Buy Now"
        flatButtonText={translate("button_GetStarted")}
        productcardclass="recommended-card"
        cardimage="Feature_Illustrations/Accents-and-dialects.svg"
        redirectURL={`/accentsanddialects`}
      />

          )
        }

      
      {!sessionStorage.getItem("isDemoUser") && isOneUser && isOneUser !== null && (
        <>
         
          {isStressAndIntonationEnabled && (
            <ProductCard
              title={translate("stress_intonation_product_headline")}
              summary={translate("stress_intonation_product_description")}
              iconFontClass="string"
              headColorClass="string"
              roundButtonText="Buy Now"
              flatButtonText={translate("button_GetStarted")}
              productcardclass="recommended-card"
              cardimage="Feature_Illustrations/Stress-and-intonation.svg"
              redirectURL={`/stressandintonation`}
            />
          )}
          {isSoundsOfEnglishEnabled && (
            <ProductCard
              title={translate("soe_product_headline")}
              summary={translate("soe_product_description")}
              iconFontClass="string"
              headColorClass="string"
              roundButtonText="Buy Now"
              flatButtonText={translate("button_GetStarted")}
              productcardclass="recommended-card"
              cardimage="Feature_Illustrations/Sounds-of-English.svg"
              redirectURL={`/soundsofenglish`}
            />
          )}
          <ProductCard
            title={"Writing center"}
            summary={"Level up your professional writing ability via our targeted resources."}
            iconFontClass="string"
            headColorClass="string"
            roundButtonText="Buy Now"
            flatButtonText={translate("button_GetStarted")}
            productcardclass="recommended-card"
            cardimage="Feature_Illustrations/Writing-center.svg"
            redirectURL={`/writingcenter`}
          />
          <ProductCard
            title={"Global community tutorials"}
            summary={
              "Improve your English language skills with this growing collection of community-developed lessons."
            }
            iconFontClass="string"
            headColorClass="string"
            roundButtonText="Buy Now"
            flatButtonText={translate("button_GetStarted")}
            productcardclass="recommended-card"
            cardimage="Feature_Illustrations/Global-community-tutorials.svg"
            redirectURL={`/globalcommunitytutorials`}
          />
        </>
      )}
    </div>
  </div>
</div>
    )}
    </>
  
  );
};

export default RecomendedCarouselComponent;
